import { PeriodOfTheDay } from '@omecare/utils';
import { useForm } from 'react-hook-form';
import {
  OpenOfficeAgendaSlotFormValues,
  openOfficeAgendaSlotFormResolver,
} from './schema';

export type OpenOfficeAgendaSlotUseForm = ReturnType<
  typeof useForm<OpenOfficeAgendaSlotFormValues>
>;

export const useOpenOfficeAgendaSlotForm = (
  defaultValues?: Partial<OpenOfficeAgendaSlotFormValues>,
) => {
  const today = new Date();
  const periodOfTheDay: PeriodOfTheDay =
    today.getHours() < 8 ? 'morning' : 'afternoon';

  const slotType = defaultValues?.slotType ?? 'mixed';

  const openOfficeAgendaSlotForm = useForm<OpenOfficeAgendaSlotFormValues>({
    resolver: openOfficeAgendaSlotFormResolver,
    defaultValues: {
      slotType,
      periodOfTheDay,
      forceWithoutAssistant: false,
      specificDates: [],
      ...defaultValues,
    },
    // mode: 'all',
  });

  return { openOfficeAgendaSlotForm };
};
